import { Space, Typography } from 'antd';
import React from 'react';
import { NavLink } from 'react-router-dom';

export function TableNameColumn(props: { name: string; description?: string; path?: string }) {
  const { Text } = Typography;

  return (
    <Space direction="vertical">
      <Text strong>{props.path ? <NavLink to={props.path}>{props.name}</NavLink> : props.name}</Text>
      {props.description && <Text type="secondary">{props.description}</Text>}
    </Space>
  );
}
